import { TaskType } from '@modeso/aumico-lib-cpmm-fe/src/lib/enums/task-type.enum';
import { SchedulePeriod } from '../enums/schedule-period.enum';

export interface WorkflowTaskForm {
    workflowTaskId?: string;
    description: string;
    taskType: TaskType;
    scheduleDay?: { id: number; name: string } | null;
    scheduleMonth?: { id: number; name: string } | null;
    schedulePeriod: { id: SchedulePeriod; name: string } | null;
}
